<div class="overview-container">
  <!-- Eyebrow + HCP -->
  <div class="ov-eyebrow">
    <ion-icon name="sparkles" aria-hidden="true"></ion-icon>
    <span>{{ 'NOVA_MEETING_OVERVIEW' | translate }}</span>
  </div>
  <h2 class="ov-hcp" *ngIf="hcpName">{{ hcpName }}</h2>

  <!-- Transcript-derived meta (only when the raw transcript is in memory) -->
  <div class="ov-meta" *ngIf="hasTranscript">
    <div class="ov-stat">
      <span class="ov-stat__value">~{{ estimatedMinutes }}<small>{{ 'NOVA_MINUTES_ABBREVIATION' | translate }}</small></span>
      <span class="ov-stat__label">{{ 'NOVA_DURATION' | translate }}</span>
    </div>
    <div class="ov-stat">
      <span class="ov-stat__value">{{ wordCount }}</span>
      <span class="ov-stat__label">{{ 'NOVA_WORDS' | translate }}</span>
    </div>
    <div class="ov-stat" *ngIf="processedAt">
      <span class="ov-stat__value">{{ processedAt | date:'shortTime' }}</span>
      <span class="ov-stat__label">{{ 'NOVA_PROCESSED' | translate }}</span>
    </div>
  </div>

  <!-- Processing skeleton -->
  <div class="ov-summary skeleton-card" *ngIf="isProcessing && !analysisData" aria-busy="true" [attr.aria-label]="'NOVA_LOADING_MEETING_SUMMARY' | translate">
    <ion-skeleton-text [animated]="true" class="skeleton-title"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="skeleton-line"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="skeleton-line w-95"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="skeleton-line w-80"></ion-skeleton-text>
  </div>

  <!-- Summary — fixed height, scrolls internally -->
  <div class="ov-summary" *ngIf="analysisData">
    <h3 class="ov-summary__title">{{ analysisData.summary_title }}</h3>
    <div class="ov-summary__scroll">
      <p class="ov-summary__text">{{ analysisData.summary }}</p>
    </div>
  </div>

  <!-- Derived insight card (sentiment breakdown + call performance) -->
  <nova-card
    *ngIf="derivedCard"
    [card]="derivedCard"
    [responseId]="responseId"
    [usage]="usage"
    (feedback)="feedback.emit($event)">
  </nova-card>

  <!-- No summary at all -->
  <div class="ov-empty" *ngIf="!analysisData && !isProcessing" role="status">
    <ion-icon name="document-text-outline" aria-hidden="true"></ion-icon>
    <p>{{ 'NOVA_NO_MEETING_SUMMARY' | translate }}</p>
  </div>

  <!-- Action footer -->
  <div class="ov-actions" *ngIf="analysisData">
    <button type="button" class="ov-btn ov-btn--primary" (click)="reAnalyze.emit()" [disabled]="isProcessing" [attr.aria-label]="'NOVA_REANALYZE_TRANSCRIPT' | translate">
      <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
      {{ 'NOVA_REANALYZE' | translate }}
    </button>
    <button type="button" class="ov-btn ov-btn--ghost" (click)="reRecord.emit()" [disabled]="isProcessing" [attr.aria-label]="'NOVA_RETRANSCRIBE_DESCRIPTION' | translate">
      <ion-icon name="mic-outline" aria-hidden="true"></ion-icon>
      {{ 'NOVA_RETRANSCRIBE' | translate }}
    </button>
  </div>

  <!-- Privacy note -->
  <p class="ov-privacy" *ngIf="analysisData || hasTranscript">
    <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
    {{ 'NOVA_PROCESSED_SECURELY_TRANSCRIPT_NOT_STORED' | translate }}
  </p>
</div>
